<template>
  <header class="bible-header">
    <div class="bible-header__main">
      <div class="bible-header__icon">
        <v-icon color="#6f8063">mdi-book-cross</v-icon>
      </div>

      <div class="bible-header__copy">
        <div class="bible-header__eyebrow">Estudo de hoje</div>
        <h1>Estudo Biblico</h1>
        <p>{{ chapterTitle || 'Capitulo em preparacao' }}</p>
      </div>
    </div>

    <div class="bible-header__side">
      <div class="bible-header__badges">
        <BiblePresenceBadge label="Voce online" :online="userOnline" />
        <BiblePresenceBadge
          :label="partnerOnline ? 'Parceira online' : 'Parceira offline'"
          :online="partnerOnline"
          online-color="#78927b"
        />
      </div>

      <v-btn
        color="#9f7d3c"
        dark
        depressed
        class="bible-header__action"
        :loading="completing"
        :disabled="!sessionId || completed"
        @click="$emit('complete')"
      >
        <v-icon left>mdi-check-circle-outline</v-icon>
        {{ completed ? 'Leitura concluida' : 'Concluir leitura' }}
      </v-btn>
    </div>
  </header>
</template>

<script>
import BiblePresenceBadge from './BiblePresenceBadge.vue';

export default {
  name: 'BibleStudyHeader',
  components: { BiblePresenceBadge },
  props: {
    chapterTitle: {
      type: String,
      default: '',
    },
    sessionId: {
      type: [Number, String],
      default: null,
    },
    userOnline: {
      type: Boolean,
      default: false,
    },
    partnerOnline: {
      type: Boolean,
      default: false,
    },
    completing: {
      type: Boolean,
      default: false,
    },
    completed: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.bible-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 22px;
  border: 1px solid rgba(111, 128, 99, 0.18);
  border-radius: 8px;
  background:
    linear-gradient(135deg, rgba(255, 252, 246, 0.96), rgba(240, 245, 242, 0.94)),
    #fffaf1;
  box-shadow: 0 14px 36px rgba(71, 59, 42, 0.08);
}

.bible-header__main {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
}

.bible-header__icon {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #edf3e9;
  border: 1px solid rgba(111, 128, 99, 0.2);
  flex-shrink: 0;
}

.bible-header__copy {
  min-width: 0;
}

.bible-header__eyebrow {
  color: #8b6d32;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
  margin-bottom: 3px;
}

.bible-header h1 {
  margin: 0;
  color: #3f372e;
  font-size: clamp(1.5rem, 3vw, 2.2rem);
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.12;
}

.bible-header p {
  margin: 5px 0 0;
  color: #6e675d;
  font-size: 1rem;
  font-weight: 500;
}

.bible-header__side {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.bible-header__badges {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.bible-header__action {
  border-radius: 8px;
  letter-spacing: 0;
  text-transform: none;
}

@media (max-width: 760px) {
  .bible-header {
    align-items: flex-start;
    flex-direction: column;
    padding: 18px;
  }

  .bible-header__side,
  .bible-header__badges,
  .bible-header__action {
    width: 100%;
  }

  .bible-header__badges {
    justify-content: flex-start;
  }
}
</style>
